import { type IMenuItemProps, Status } from 'shared/ui'
import {
  CampaignsPath,
  ChatbotPath,
  ClickToTextPath,
  HubspotWorkflowsPath,
  KeywordsPath,
  KnowledgeBasePath,
  WorkflowsPath,
} from 'entities/ExportRouters'

export const AIAutomationKey = 'AIAutomation'

export const subItemsMenuAIAutomationActive = [
  ChatbotPath.root,
  ChatbotPath.all,
  ChatbotPath.new,
  ChatbotPath.analytic,

  KnowledgeBasePath.root,

  CampaignsPath.root,
  CampaignsPath.all,

  WorkflowsPath.root,
  HubspotWorkflowsPath.root,
  KeywordsPath.root,
  ClickToTextPath.root,
]

export enum EnumMenuAIAutomationItemsKey {
  ai_agents = 'ai_agents',
  chatbot = 'chatbot',
  knowledge_base = 'knowledge_base',
  campaigns = 'campaigns',
  workflows = 'workflows',
  hubspot_workflows = 'hubspot_workflows',
  keywords = 'keywords',
  click_to_text = 'click_to_text',
}

export const listItemsAIAutomation = {
  [EnumMenuAIAutomationItemsKey.chatbot]: ChatbotPath.root,
  [EnumMenuAIAutomationItemsKey.knowledge_base]: KnowledgeBasePath.root,
  [EnumMenuAIAutomationItemsKey.campaigns]: CampaignsPath.root,
  [EnumMenuAIAutomationItemsKey.workflows]: WorkflowsPath.root,
  [EnumMenuAIAutomationItemsKey.hubspot_workflows]: HubspotWorkflowsPath.root,
  [EnumMenuAIAutomationItemsKey.keywords]: KeywordsPath.root,
  [EnumMenuAIAutomationItemsKey.click_to_text]: ClickToTextPath.root,
}

export const menuItems: IMenuItemProps<EnumMenuAIAutomationItemsKey>[] = [
  {
    key: EnumMenuAIAutomationItemsKey.ai_agents,
    type: 'sub',
    label: 'AI Agents',
    icon: 'stars',
    items: [
      {
        key: EnumMenuAIAutomationItemsKey.chatbot,
        type: 'nav',
        to: ChatbotPath.root,
        fullPath: true,
        label: 'Agents',
      },
      {
        key: EnumMenuAIAutomationItemsKey.knowledge_base,
        type: 'nav',
        to: KnowledgeBasePath.root,
        fullPath: true,
        label: 'Knowledge base',
      },
    ],
    rightContent: <Status title={'Beta'} intent={'warning'} emphasis={'high'} size={'label'} />,
  },
  {
    key: EnumMenuAIAutomationItemsKey.campaigns,
    type: 'nav',
    to: CampaignsPath.root,
    fullPath: true,
    label: 'Campaigns',
    icon: 'campaigns',
    disabled: false,
    rightContent: <Status title={'New'} intent={'purple'} emphasis={'high'} size={'label'} />,
  },
  {
    key: EnumMenuAIAutomationItemsKey.workflows,
    type: 'nav',
    to: WorkflowsPath.root,
    fullPath: true,
    label: 'Workflows',
    icon: 'workflows',
  },
  {
    key: EnumMenuAIAutomationItemsKey.hubspot_workflows,
    type: 'nav',
    to: HubspotWorkflowsPath.root,
    fullPath: true,
    label: 'Hubspot Workflows',
    icon: 'hubspotMenu',
    rightContent: <Status title={'New'} intent={'purple'} emphasis={'high'} size={'label'} />,
  },
  {
    key: EnumMenuAIAutomationItemsKey.keywords,
    type: 'nav',
    to: KeywordsPath.root,
    fullPath: true,
    label: 'Keywords',
    icon: 'keywords2',
  },
  {
    key: EnumMenuAIAutomationItemsKey.click_to_text,
    type: 'nav',
    to: ClickToTextPath.root,
    fullPath: true,
    label: 'Click to text',
    icon: 'qr',
    rightContent: <Status title={'New'} intent={'purple'} emphasis={'high'} size={'label'} />,
  },
]
